var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-registration-box event-box-shadow" }, [
    _c(
      "div",
      { staticClass: "event-card-main-head" },
      [
        _c("div", { staticClass: "event-card-top-head" }, [
          _vm.registrationClosed
            ? _c("span", { staticClass: "event-select-title" }, [
                _vm._v("Registration closed"),
              ])
            : _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("span", { staticClass: "event-select-title" }, [
                  _vm._v(_vm._s(_vm.labels["ticket-label-selection"])),
                ]),
                _vm._v(" "),
                _vm.item.PricingGstApplicable
                  ? _c("span", { staticClass: "event-price-gst" }, [
                      _vm._v(_vm._s(_vm.labels["ticket-label-gst"])),
                    ])
                  : _vm._e(),
              ]),
        ]),
        _vm._v(" "),
        _vm.registrationClosed
          ? _c("div", { staticClass: "p-4" }, [
              _c("p", [_vm._v("Registration for this event has closed.")]),
            ])
          : _vm._l(_vm.availableTickets, function (option, index) {
              return _c("ticket-option", {
                key: index,
                attrs: {
                  item: option,
                  labels: _vm.labels,
                  id: index,
                  conflictCode: _vm.conflictCode,
                  tickets: _vm.tickets,
                  registrationLockedCode: _vm.registrationLockedCode,
                  singleTicketOption: _vm.availableTickets.length === 1,
                },
                on: {
                  "checked-registration-locked": function ($event) {
                    _vm.registrationLockedCode = $event
                  },
                  "select-number-of-ticket": _vm.onSelectNumberOfTicket,
                  "checked-conflict-code": _vm.onConflictCodeChecked,
                },
              })
            }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "event-card-body flex flex-end" }, [
      !_vm.valid
        ? _c(
            "div",
            { staticClass: "mb-3 px-4" },
            [
              _c("el-alert", {
                attrs: {
                  title: _vm.labels["ticket-validation-noselection"],
                  type: "error",
                  "show-icon": "",
                },
                on: {
                  close: function ($event) {
                    _vm.valid = true
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isValidMaximumAttendess
        ? _c(
            "div",
            { staticClass: "mb-3 px-4" },
            [
              _c("el-alert", {
                attrs: {
                  title: _vm.labels["QtyExceededMessage"].replace(
                    "[MaximumAttendees]",
                    _vm.item.MaximumAttendees
                  ),
                  type: "error",
                  "show-icon": "",
                },
                on: {
                  close: function ($event) {
                    _vm.isValidMaximumAttendess = true
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.registrationClosed
        ? _c(
            "div",
            { staticClass: "event-btn d-flex flex-wrap flex-end ml-auto" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary ml-auto",
                  attrs: { type: "button" },
                  on: { click: _vm.onNextClick },
                },
                [
                  _vm._v("Next "),
                  _c("i", { staticClass: "far fa-arrow-right ml-2" }),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }